import React, { Fragment } from 'react'

const BlockStyleFive = (props = {}) => {
    const {
        kicker = '구축 사례 영상',
        title = '실제 운영 환경을 고려한 안정적인 시스템 구축',
        body = '개발 완료가 목표가 아닙니다. 기업이 안정적으로 운영할 수 있는 시스템, 성장에 따라 확장할 수 있는 구조까지 고려합니다.',
    } = props
    return (
        <Fragment>
            <div className="block-style-five ps-xxl-5 ms-xxl-4">
                <h6 className="sub-title mb-20" data-aos="fade-up">
                    {kicker}
                </h6>
                <h3 className="sect-title mb-20">{title}</h3>
                <p className="pe-xxl-5 mb-55">{body}</p>
            </div>
        </Fragment>
    )
}

export default BlockStyleFive
